/*
 * @Author: your name
 * @Date: 2021-06-16 18:12:47
 * @LastEditTime: 2021-11-24 10:20:30
 * @LastEditors: name
 * @Description: In User Settings Edit
 * @FilePath: \dtpWeb\src\assets\api\newApi.js
 */
import request from '@/utils/axios_gispai'

export default {
  // 获取渲染值
  GetFiledValueByIDs (params) {
    return request({
      url: 'api/Edition/GetFiledValueByIDs',
      method: 'post',
      data: params
    })
  },
  // 压缩数据/融合
  saveToGDB (params) {
    return request({
      url: 'api/GData/SaveToGDB?GDataId=' + params.GDataId + '&UserId=' + params.UserId,
      method: 'get',
      data: params
    })
  },
  // 解除数据锁
  relieveLock (params) {
    return request({
      url: 'api/GData/RelieveGDataState',
      method: 'post',
      data: params
    })
  },
  // 清除数据缓存
  DeleteTitles (params) {
    return request({
      url: 'api/Edition/DeleteTitles',
      method: 'post',
      data: params
    })
  },
  // 是否可拾取（数据）
  updateGDataIsPickup (params) {
    return request({
      url: 'api/GData/UpdateGDataIsPickup',
      method: 'post',
      data: params
    })
  },

  UpdataIsTileMode (params) {
    return request({
      url: 'api/GData/UpdataIsTileMode',
      method: 'get',
      params: params
    })
  },
  // 是否可拾取（图层）
  updateLayerIsPickup (params) {
    return request({
      url: '/api/MapDoc/UpdateLayerIsPickup',
      method: 'post',
      data: params
    })
  },
  // 获取第三方地图的token
  getMapDocToken (params) {
    return request({
      url: 'api/MapDoc/GetMapDocToken',
      method: 'get',
      params: params
    })
  },
  // 设置第三方token
  updateMapDocToken (params) {
    return request({
      url: 'api/MapDoc/UpdateMapDocToken',
      method: 'post',
      data: params
    })
  },
  //在线影像查询接口
  getOnlineImage (params) {
    return request({
      url: 'api/OnlineToPrivate/GetOnlineImage',
      method: 'get',
      params: params
    })
  },
  // 在线影像修改底图
  updateBaseMap_image (params) {
    return request({
      url: 'api/BaseMapParameter/updateBaseMapParameter_open',
      method: 'post',
      data: params
    })
  },
  getBaseMapParameter (params) {
    return request({
      url: 'api/BaseMapParameter/getBaseMapParameter',
      method: 'get',
      params: params
    })
  },
  updateLayerTitleMaxLevel (params) {
    return request({
      url: 'api/MapDoc/UpdateLayerTitleMaxLevel',
      method: 'post',
      data: params
    })
  },

  // 获取符号分类列表
  getSymbolClassList (params) {
    return request({
      url: 'api/SymbolManagement/GetSymbolClassList',
      method: 'post',
      data: params
    })
  },
  // 根据类型获取所有的符号分类
  getSymbolClassListbyType (params) {
    return request({
      url: 'api/SymbolManagement/GetSymbolClassListbyType',
      method: 'post',
      data: params
    })
  },
  // 修改符号管理 /
  updateSymbolManagement (params) {
    return request({
      url: 'api/SymbolManagement/UpdateSymbolManagement',
      method: 'post',
      data: params
    })
  },
  // 删除符号管理
  deleteSymbolManagement (params) {
    return request({
      url: 'api/SymbolManagement/DeleteSymbolManagement',
      method: 'post',
      data: params
    })
  },
  // 添加符号分类
  addSymbolClass (params) {
    return request({
      url: 'api/SymbolManagement/AddSymbolClass',
      method: 'post',
      data: params
    })
  },
  //修改符号分类 /
  updateSymbolClass (params) {
    return request({
      url: 'api/SymbolManagement/UpdateSymbolClass',
      method: 'post',
      data: params
    })
  },
  // 删除符号分类 /
  deleteSymbolClass (params) {
    return request({
      url: 'api/SymbolManagement/DeleteSymbolClass',
      method: 'post',
      data: params
    })
  },
  //获取符号管理列表
  getSymbolManagementListByClass (params) {
    return request({
      url: 'api/SymbolManagement/GetSymbolManagementListByClass',
      method: 'post',
      data: params
    })
  },
  // 添加符号
  addSymbolManagement (params) {
    return request({
      url: 'api/SymbolManagement/AddSymbolManagement',
      method: 'post',
      data: params
    })
  },
  // 获取我的符号类
  getMySymbol (params) {
    return request({
      url: 'api/SymbolManagement/GetMySymbol',
      method: 'post',
      data: params
    })
  },
  // 修改符号类的排序字符串
  updateMySymbol (params) {
    return request({
      url: 'api/SymbolManagement/UpdateMySymbol',
      method: 'post',
      data: params
    })
  },
  // 获取公开地图数据 /
  getOpenMapDataList (params) {
    return request({
      url: 'api/OpenMapData/GetOpenMapDataList',
      method: 'get',
      params: params
    })
  },
  // 设置公开地图权限
  updataOpenMapDataPower (params) {
    return request({
      url: 'api/OpenMapData/UpdataOpenMapDataPower',
      method: 'get',
      params: params
    })
  },
  // 添加公开地图
  addOpenMapGData (params) {
    return request({
      url: 'api/OpenMapData/AddOpenMapGData',
      method: 'get',
      params: params
    })
  },
  // 删除公开地图
  deleteOpenMapData (params) {
    return request({
      url: 'api/OpenMapData/DeleteOpenMapData',
      method: 'get',
      params: params
    })
  },
  //设置公开地图文件名 /
  updateOpenMapDataFolderName (params) {
    return request({
      url: 'api/OpenMapData/UpdateOpenMapDataFolderName',
      method: 'get',
      params: params
    })
  },
  // 设置公开地图父文件 /
  updateOpenMapDataParent (params) {
    return request({
      url: 'api/OpenMapData/UpdateOpenMapDataParent',
      method: 'get',
      params: params
    })
  },
  // 设置公开地图权限 /
  updataOpenMapDataPower (params) {
    return request({
      url: 'api/OpenMapData/UpdataOpenMapDataPower',
      method: 'get',
      params: params
    })
  },
  // 获取公开数据详情
  getOpenGDataOne (params) {
    return request({
      url: 'api/OpenGData/GetOpenGDataOne',
      method: 'get',
      params: params
    })
  },
  // 获取公开数据详情
  getOpenMapOne (params) {
    return request({
      url: 'api/OpenMapData/GetOpenMapDataOne',
      method: 'get',
      params: params
    })
  },
  // 修改排序
  updateOrderNumber (params) {
    return request({
      url: 'api/SymbolManagement/UpdateOrderNumber',
      method: 'post',
      data: params
    })
  },
  // 获取数据库数据（新）
  getAllTableData (params) {
    return request({
      url: 'api/GData/GetAllTableData',
      method: 'get',
      params: params
    })
  },
  // 获取所有数据（新）
  GetGData (params) {
    return request({
      url: 'api/GData/GetGData',
      method: 'get',
      params: params
    })
  },


  //微信登陆
  loginByWeChat (params) {
    return request({
      url: 'api/User/loginByWeChat',
      method: 'post',
      data: params
    })
  },

  // 获取单个图层数据
  GetLayerInfoById(params) {
    return request({
      url: '/api/MapDoc/GetLayerInfoById',
      method: 'get',
      params: params
    })
  }
}
